import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEmployee } from './firebase';
import {
  STATUS_IDLE,
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const fetchEmployee = createAsyncThunk('fetchEmployee', async (params) => await getEmployee(params));

const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    status: STATUS_IDLE,
    data: null
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchEmployee.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchEmployee.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.data = action.payload
      })
      .addCase(fetchEmployee.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default employeeSlice.reducer
